<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="350">
      <v-card>
        <v-card-title
          class="headline body-1 blue-grey darken-1 lighten-1 white--text font-weight-thin"
          primary-title
        >
          <v-icon class="white--text mr-2">mdi-shield-lock</v-icon>Actualizar
          palavra-passe
        </v-card-title>
        <v-card-text class="pa-8">
          <v-form novalidate ref="form" v-model="valid" lazy-validation>
            <v-text-field
              v-model="newPassword"
              :rules="pwdRules"
              label="Digite a nova palavra-passe"
              required
              filled
              :append-icon="value ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="() => (value = !value)"
              :type="value ? 'password' : 'text'"
            ></v-text-field>

            <v-text-field
              v-model="repeatPassword"
              :rules="pwdRules"
              label="Repita a palavra-passe"
              required
              filled
              :append-icon="value ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="() => (value = !value)"
              :type="value ? 'password' : 'text'"
            ></v-text-field>
            <v-card-actions>
              <v-btn
                color="green lighten-2"
                text
                block
                @click="updatePass"
                :disabled="!valid"
                :loading="loading"
              >
                Actualizar
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue-grey" text @click="dialog = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import eventBus from "../../../../main";
export default {
  name: "OpenChangeSecurity",
  data: () => ({
    newPassword: "",
    repeatPassword: "",
    dialog: false,
    valid: true,
    value: true,
    loading: false,
    pwdRules: [
      v => !!v || "Palavra-passe é requerida",
      v => (v && v.length >= 6) || "Deve ter no mínimo 6 caracter",
      v =>
        /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*\W+)(?=^.{6,15}$).*$/.test(v) ||
        "Deve ter minúsculas, maísculas e caracter especial"
    ]
  }),
  methods: {
    updatePass() {
      if (this.$refs.form.validate()) {
        const payload = {
          newPassword: this.newPassword,
          repeatPassword: this.repeatPassword
        };
        this.$store.dispatch("createNewPwdEnterprise", payload);
      }
    }
  },
  created() {
    const self = this;
    eventBus.$on("openChangeSecurity", function(value) {
      self.dialog = value;
      self.newPassword = "";
      self.repeatPassword = "";
    });
  }
};
</script>

<style scoped>
.m-center {
  text-align: center;
}
</style>
